exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dashboardGrid[data-v-1f79daf6] {\n    display: grid;\n    grid-template-columns: 1fr;\n}\n", ""]);

// exports
